var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.count > 0)?_c('span',{staticClass:"kt-badge tab-count-badge",class:{
    'kt-badge--primary': _vm.type === 'primary',
    'kt-badge--secondary': _vm.type === 'secondary',
  },domProps:{"textContent":_vm._s(_setup.countText)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }